module.exports = __webpack_public_path__ + "static/media/snapchatIcon.8eedfd97.svg";